export const getUrlParams = () => {
	const queryString = window.location.search;
	return new URLSearchParams(queryString);
};

export const getUrlParam = (name: string) => {
	const params = getUrlParams();
	/* istanbul ignore if: no need to test this */
	if (params.has(name)) {
		return params.get(name);
	}
	return null;
};
